import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Components/Common/Sidebar";
import Navbar from "./Components/Common/Navbar";
import MiniSidebar from "./Components/Common/MiniSidebar";
import { useNavigate } from "react-router-dom";
import ParentLayout from "./layouts/ParentLayout";
import { useTranslation } from "react-i18next";
import { adminLinks, hrLinks } from "../src/Constant/sidebarlinks";
import { setRoleView } from "./redux/ToggleSlice";
import { useDispatch } from "react-redux";

const ProtectedRoute = (props) => {
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { Component } = props;
  const location = useLocation();
  const auth = JSON.parse(localStorage.getItem("user"));
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const roleView = localStorage.getItem("roleView") || "admin";

  useEffect(() => {
    if (!auth) {
      return navigate("/");
    }

    if (auth.user === "admin") {
      if (
        auth.user === "admin" &&
        permissions.length === 1 &&
        permissions[0] === "HRMS"
      ) {
        dispatch(setRoleView("hr")); // Now properly imported
        localStorage.setItem("roleView", "hr");
      }
      const isRouteAccessible = () => {
        
        if (location.pathname === '/account-settings') return true;

        const routes = roleView === "admin" ? adminLinks(t) : hrLinks(t);

        return routes.some((route) => {
          if (route.path === location.pathname) {
            return !route.permission || permissions.includes(route.permission);
          }
          if (route.children) {
            return route.children.some(
              (child) =>
                child.path === location.pathname &&
                (!child.permission || permissions.includes(child.permission))
            );
          }
          return false;
        });
      };

      if (!isRouteAccessible()) {
        const routes = roleView === "admin" ? adminLinks(t) : hrLinks(t);
        const firstAccessibleRoute = findFirstAccessibleRoute(
          routes,
          permissions
        );
        navigate(firstAccessibleRoute);
      }
    }
  }, [auth, location.pathname, roleView]);

  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [toggle]);

  const handleToggleSidebar = () => {
    setToggle(true);
  };

  const isArabic = i18n.language;

  return (
    <>
      {auth && (
        <section
          className={`d-flex w-100 custom-scrollbar sidebarMediumS ${
            isArabic === "sa" ? "flex-row-reverse" : ""
          }`}
        >
          {location.pathname === "/assesment-welcome" ||
          location.pathname === "/assesment" ? null : (
            <>
              <MiniSidebar toggle={toggle} setToggle={setToggle} />
              <Sidebar />
            </>
          )}
          <div className="d-flex flex-column w-full w-100 position-relative">
            <Navbar handleToggleSidebar={handleToggleSidebar} />
            <main
              className={
                location.pathname === "/assesment"
                  ? "assesmentsWrapper "
                  : "routesWrapper mainComponent "
              }
            >
              {auth.user === "parent" ? (
                <ParentLayout>{<Component />}</ParentLayout>
              ) : (
                <Component />
              )}
            </main>
          </div>
        </section>
      )}
    </>
  );
};

// Helper function to find first accessible route (only used for admin/HR)
const findFirstAccessibleRoute = (routes, permissions) => {
  for (const route of routes) {
    if (!route.permission || permissions.includes(route.permission)) {
      if (route.children) {
        const accessibleChild = route.children.find(
          (child) => !child.permission || permissions.includes(child.permission)
        );
        if (accessibleChild) return accessibleChild.path;
      }
      return route.path;
    }
  }
  return "/no-access";
};

export default ProtectedRoute;
